import { Scenario } from "@/pages/scenario-builder/types";
import { calculateROI } from "@/pages/scenario-builder/v3/utils/spend-revenue-summary";
import { z } from "zod";

export const scenarioOptionFromScenario = (scenario: Scenario): ScenarioOption => ({
  uuid: scenario.uuid,
  name: scenario.name,
  businessUnit: scenario.brand,
  geography: scenario.geography,
  startDate: !isNaN(scenario.startDate.getTime()) ? scenario.startDate.toISOString() : null,
  endDate: !isNaN(scenario.endDate.getTime()) ? scenario.endDate.toISOString() : null,
  plannedSpend: scenario.spend,
  forecastRevenue: scenario.revenue,
  estimatedROI: calculateROI({ spend: scenario.spend, revenue: scenario.revenue }),
});

// Scenario option for dropdown
export type ScenarioOption = {
  uuid: string;
  name: string;
  businessUnit: string;
  geography: string | null | undefined;
  startDate: string | null;
  endDate: string | null;
  plannedSpend: number;
  forecastRevenue: number;
  estimatedROI: number | null | undefined;
};

// Form validation schema
export const actionPlanFormSchema = z.object({
  name: z.string().min(1, "Name is required").max(128, "Name must be less than 128 characters"),
  scenarioId: z.string().min(1, "Base Scenario is required"),
});

export type ActionPlanFormData = z.infer<typeof actionPlanFormSchema>;
